import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import WhatIsMulebuySpreadsheet from "@/pages/articles/what-is-mulebuy-spreadsheet/page";
import BestMulebuySpreadsheets from "@/pages/articles/best-mulebuy-spreadsheets/page";
import MulebuyAgentsComparison from "@/pages/articles/mulebuy-agents-comparison/page";
import IsMulebuySpreadsheetSafe from "@/pages/articles/is-mulebuy-spreadsheet-safe/page";
import BlogGuide2026 from "@/pages/articles/blog/mulebuy-spreadsheet-guide-2026/page";
import ShoppingGuide from "@/pages/articles/shopping-guide/page";
import BlogVsAgent from "@/pages/articles/blog/mulebuy-spreadsheet-vs-agent/page";
import BlogHowToUse from "@/pages/articles/blog/how-to-use-mulebuy-spreadsheet/page";
import BlogBenefits from "@/pages/articles/blog/mulebuy-spreadsheet-benefits/page";
import BlogPricing from "@/pages/articles/blog/mulebuy-spreadsheet-pricing/page";
import BlogTips from "@/pages/articles/blog/mulebuy-spreadsheet-tips/page";
import BlogMistakes from "@/pages/articles/blog/mulebuy-spreadsheet-mistakes/page";
import BlogBeginners from "@/pages/articles/blog/mulebuy-spreadsheet-beginners/page";
import BlogUpdateFreq from "@/pages/articles/blog/mulebuy-spreadsheet-update-frequency/page";
import BlogSuccess from "@/pages/articles/blog/mulebuy-spreadsheet-success-stories/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/what-is-mulebuy-spreadsheet", element: <WhatIsMulebuySpreadsheet /> },
  { path: "/best-mulebuy-spreadsheets", element: <BestMulebuySpreadsheets /> },
  { path: "/mulebuy-agents-comparison", element: <MulebuyAgentsComparison /> },
  { path: "/is-mulebuy-spreadsheet-safe", element: <IsMulebuySpreadsheetSafe /> },
  { path: "/blog/mulebuy-spreadsheet-guide-2026", element: <BlogGuide2026 /> },
  { path: "/shopping-guide", element: <ShoppingGuide /> },
  { path: "/blog/mulebuy-spreadsheet-vs-agent", element: <BlogVsAgent /> },
  { path: "/blog/how-to-use-mulebuy-spreadsheet", element: <BlogHowToUse /> },
  { path: "/blog/mulebuy-spreadsheet-benefits", element: <BlogBenefits /> },
  { path: "/blog/mulebuy-spreadsheet-pricing", element: <BlogPricing /> },
  { path: "/blog/mulebuy-spreadsheet-tips", element: <BlogTips /> },
  { path: "/blog/mulebuy-spreadsheet-mistakes", element: <BlogMistakes /> },
  { path: "/blog/mulebuy-spreadsheet-beginners", element: <BlogBeginners /> },
  { path: "/blog/mulebuy-spreadsheet-update-frequency", element: <BlogUpdateFreq /> },
  { path: "/blog/mulebuy-spreadsheet-success-stories", element: <BlogSuccess /> },
  { path: "*", element: <NotFound /> },
];

export default routes;